module.exports = __webpack_public_path__ + "cb2795bebba4bedd5e0c15188561df4b.svg";